import Address from "../components/Address";
import { MenuBar } from "../components/MenuBar";
import mainImg from "../images/banner01.png";
import mapImg from "../images/map.jpg";
import youtubeLink from "../images/utub.png";
import "./Main.css";
const Main = () => {
  return (
    <div className="main_container">
      <MenuBar selected_page="" />

      <img src={mainImg} className="main_image" />

      <div className="youtube_banner">
        <a
          href="https://www.youtube.com/channel/UCSUW_pGH6ru65irfT4I7sog"
          target="_blank"
          rel="noreferrer"
        >
          <div className="youtube_image">
            <img src={youtubeLink} className="youtube_link" />
          </div>
        </a>
      </div>

      <Address />
    </div>
  );
};
export default Main;
